import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/assests/css/index.css';
import { BrowserRouter } from 'react-router-dom';
import App from '../src/components/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>

);

